import IframeWithOtp from "../components/IframeWithOtp";
import config from "../config";


export function LegacyProfilePage()  {
  return <IframeWithOtp src={`${config.apps.leagueDashboard}/account/edit`} id="user-profile"/>
}
